import React, {useState, useMemo, useEffect} from "react";
import {useTable} from 'react-table';
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/shared/pagination/index";
import { getVisits } from "../../../client/administration/list/index";
import '../../../../src/index.css'; 
import { getEvents } from "../../../client/administration/event";
import { format } from 'date-fns'; 
import { es } from 'date-fns/locale';

const TableList = ({ records, recordsPerPage, onCurrentPageRecordsCountChange }) => {
  const navigate = useNavigate();
  const [visits, setVisits] = useState([]);
  

  useEffect(() => {
    fetchVisits();
  }, []);
  
  const fetchVisits = async () => {
    try {
        const response = await getVisits(); // Obtener todas las visitas
        const visitsData = response.data;
        const eventsResponse = await getEvents(); // Obtener todos los eventos
        const eventsData = eventsResponse.data;

        // Crear un conjunto de IDs de eventos para facilitar la búsqueda
        const eventIds = new Set(eventsData.map(event => event.idVisit));

        //Obtener hora actual
        const currentTime = new Date();

        // Mapeo de visitas para incluir el estado "Agendado"
        const updatedVisits = visitsData.map(visit => {
            // Verifica si la visita tiene un evento asociado
            const hasEvent = eventIds.has(visit.id);

            if (hasEvent) {
                // Si hay un evento, busca el evento correspondiente
                const matchingEvent = eventsData.find(event => event.idVisit === visit.id);
                
                // Verifica el estado del ouputWeighting
                if (matchingEvent.ouputWeighting > 0) {
                    return { ...visit, estado: "Salió" };
                } else {
                    return { ...visit, estado: "Entró" };
                }
            }
            // Si no hay evento asociado, asigna el estado "Agendado"
            return { ...visit, estado: "Agendado" };
        });
        // Agregar lógica para "Retraso"
        const finalUpdatedVisits = updatedVisits.map(visit => {
          const finalDate = new Date(visit.finalDateScheduled);
          const tenMinutesLater = new Date(finalDate.getTime() + 10 * 60 * 1000); // 10 minutos en milisegundos
        
          if (!eventIds.has(visit.id) && currentTime > tenMinutesLater) {
            return { ...visit, estado: "Retraso" };
          }
          return visit;
        });

        setVisits(finalUpdatedVisits);
    } catch (error) {
        console.error('Error fetching visits:', error);
    }
};

const handleDetailsClick = async (visit) => {
  try {
    const { data: events } = await getEvents();
    
    // Filtrar eventos que coincidan con la visita seleccionada
    const visitEvents = events.filter(event => event.visit.idVisiTasa === visit.idVisiTasa);
    console.log("visitEvents:", visitEvents);
    if (visitEvents.length > 0) {
      // Si hay eventos asociados, redirigir a TicketGenerated y pasar los eventos
      navigate("/tickets-generados", { state: { events: visitEvents } });
    } else {
      // Si no hay eventos, redirigir a detalle-ticket con los datos de la visita
      navigate("/detalle-ticket", { state: { eventData: visit } });
    }
  } catch (error) {
    console.error("Error al obtener eventos:", error);
    navigate("/detalle-ticket", { state: { eventData: visit } });
  }
};

  const [currentPage, setCurrentPage] = useState(1);
  const totalRecords = records.length;
  const initialIndex = (currentPage - 1) * recordsPerPage;
  const finalIndex = initialIndex + recordsPerPage;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);


  const getPaginatedRecords = () => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
    return records.slice(startIndex, endIndex);
};

const formatVisitDateRange = (startDateScheduled, finalDateScheduled) => {
  const startDate = new Date(startDateScheduled);
  const finalDate = new Date(finalDateScheduled);

  // Formatear las fechas
  const startDateFormatted = format(startDate, 'dd \'de\' MMMM hh:mm a', { locale: es });
  const finalDateFormatted = format(finalDate, 'hh:mm a', { locale: es });

  // Comparar las fechas
  if (startDate.toDateString() === finalDate.toDateString()) {
      // Si la visita termina el mismo día
      return `${startDateFormatted} a ${finalDateFormatted}`;
  } else {
      // Si termina en otra fecha
      const finalDateDayFormatted = format(finalDate, 'dd \'de\' MMMM', { locale: es });
      return `${startDateFormatted} a ${finalDateDayFormatted} ${finalDateFormatted}`;
  }
};
const recordsPage = getPaginatedRecords(); 


const getCurrentPageRecordsCount = () => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = Math.min(currentPage * recordsPerPage, visits.length);
    return endIndex - startIndex;
};


const changePage = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setCurrentPage(newPage);
  }
};

useEffect(() => {
    if (onCurrentPageRecordsCountChange) {
        onCurrentPageRecordsCountChange(recordsPage.length);
    }
}, [recordsPage, onCurrentPageRecordsCountChange]);


const statusColors = {
    "Agendado": "#184A7D",
    "Entró": "#43B02A",
    "Salió": "#FFB81C",
    "Retraso": "#E44949",
  };



  const columns = useMemo(() => [
    {
      Header: '#',
      accessor: 'id',
      style: { width: '50px' }, 
     // Cell: ({ row }) => initialIndex + row.index + 1,
      
    },
    {
      Header: 'Placa',
      accessor: 'plate',
      style: { width: '150px' } 
    },
    {
      Header: 'Tipo de vehículo',
      accessor: 'typeVehicle',
      style: { width: '150px' } 
    },
    {
      Header: 'Estado',
      accessor: 'estado',
      style: { width: '150px' },
      Cell: ({ value }) => {
          return (
              <div className="flex items-center justify-center">
                  <p className="rounded-[5px] font-rubikmedium flex justify-center items-center text-[10px] w-[82px] h-[23px] text-white"
                     style={{ backgroundColor: statusColors[value] }}>
                     {value}
                  </p>
              </div>
          );
      }
  },
    {
      Header: 'Conductor',
      accessor: 'driverName',
      style: { width: '180px' } 
    },
    {
      Header: 'DNI',
      accessor: 'dni',
      style: { width: '150px' } 
    },
    {
      Header: 'Empresa',
      accessor: 'companyName',
      style: { width: '200px' } 
    },
    {
      Header: 'Fecha agendada',
      accessor: 'finaltDateScheduled',
      style: { width: '190px' },
      Cell: ({ row }) => (
        <span>{formatVisitDateRange(row.original.startDateScheduled, row.original.finalDateScheduled)}</span>
      )
    },

    /*
    {
      Header: 'Personas',
      accessor: 'personas',
      Cell: ({ value }) => `${value ?? 0} en total`
    },*/
    {
      Header: 'Detalles',
      accessor: 'detalles',
      style: { width: '100px' } ,
      Cell: ({row}) => (
        <div className="flex items-center justify-center">
          <button 
             onClick={() => handleDetailsClick(row.original)}
            className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.6631 7.42051C17.5338 2.93506 14.3152 0.677734 10.0004 0.677734C5.68341 0.677734 2.46701 2.93506 0.337709 7.42275C0.252302 7.6036 0.208008 7.80112 0.208008 8.00112C0.208008 8.20112 0.252302 8.39864 0.337709 8.57949C2.46701 13.0649 5.68566 15.3223 10.0004 15.3223C14.3174 15.3223 17.5338 13.0649 19.6631 8.57725C19.8361 8.21338 19.8361 7.79111 19.6631 7.42051ZM10.0004 13.7051C6.37746 13.7051 3.72482 11.8678 1.85382 8C3.72482 4.13223 6.37746 2.29492 10.0004 2.29492C13.6234 2.29492 16.276 4.13223 18.147 8C16.2782 11.8678 13.6256 13.7051 10.0004 13.7051ZM9.91056 4.04688C7.72736 4.04688 5.95744 5.8168 5.95744 8C5.95744 10.1832 7.72736 11.9531 9.91056 11.9531C12.0938 11.9531 13.8637 10.1832 13.8637 8C13.8637 5.8168 12.0938 4.04688 9.91056 4.04688ZM9.91056 10.5156C8.52023 10.5156 7.39494 9.39033 7.39494 8C7.39494 6.60967 8.52023 5.48438 9.91056 5.48438C11.3009 5.48438 12.4262 6.60967 12.4262 8C12.4262 9.39033 11.3009 10.5156 9.91056 10.5156Z" fill="black"/>
            </svg>
          </button>
        </div>
      )
    },
    {
      Header: 'Evento de pesaje',
      accessor: 'eventoPesaje',
      style: { width: '100px' } ,
      Cell: ({row}) => {
        const navigate = useNavigate();
        const visitData = row.original;
        
        // Buscar si la visita ya tiene un evento de salida pendiente
        const isSalida = visitData.events && visitData.events.some(event => event.ouputWeighting === null);
        
        const handleNavigate = () => {
          navigate("/registro-ticket", { state: { visitData, visitaData: visitData, isSalida } });
        };
    
        return (
        <div className="flex items-center justify-center">
          <button 
            onClick={handleNavigate} 
            className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 15.5C22.9989 13.4958 22.4181 11.5348 21.3275 9.85328L20.2445 10.937C21.066 12.3173 21.4998 13.8938 21.5 15.5H23ZM21.5 7.56053L20.4395 6.50003L14.0143 12.9253C13.5571 12.6497 13.0339 12.5028 12.5 12.5C11.9067 12.5 11.3267 12.676 10.8333 13.0056C10.34 13.3353 9.95544 13.8038 9.72838 14.352C9.50131 14.9002 9.4419 15.5034 9.55766 16.0853C9.67341 16.6672 9.95914 17.2018 10.3787 17.6214C10.7983 18.0409 11.3328 18.3266 11.9147 18.4424C12.4967 18.5581 13.0999 18.4987 13.6481 18.2717C14.1962 18.0446 14.6648 17.6601 14.9944 17.1667C15.3241 16.6734 15.5 16.0934 15.5 15.5C15.4974 14.9659 15.3505 14.4425 15.0748 13.985L21.5 7.56053ZM12.5 6.50003C14.106 6.50043 15.6822 6.93417 17.0623 7.75553L18.1528 6.66578C16.568 5.64666 14.7379 5.0735 12.8549 5.00661C10.9719 4.93972 9.10576 5.38156 7.45268 6.28566C5.79961 7.18976 4.42077 8.52268 3.46123 10.1442C2.50168 11.7657 1.99691 13.6159 2.00001 15.5H3.50001C3.50279 13.1139 4.4519 10.8264 6.13912 9.13914C7.82635 7.45191 10.1139 6.50281 12.5 6.50003Z" fill="black"/>
            </svg>
          </button>
        </div>
        );
      }
    }
  ], [initialIndex]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: recordsPage });

  return (
    <div className="max-w-full">
      <div className="max-w-full overflow-x-auto scroll-container">
        <table {...getTableProps()} className="w-full border-collapse table-fixed">
          <thead className="bg-white">
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()} className="h-[47px] text-sm font-itcbold text-center">
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()}
                  style={column.style} className={`px-[7px] py-2 border border-[#D9D9D9] ${column.id === "id" ? "w-[6%]" : "w-auto" } `}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className={`overflow-hidden text-sm border-collapse h-[47px] font-itcmedium text-center ${row.index % 2 === 0 ? "bg-white" : "bg-[#EBEBEB]/[0.2]"}`}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()} className="px-[7px] py-5 border border-[#D9D9D9]">{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <div className="flex flex-col items-center justify-between mt-6 space-x-4 space-y-2 md:flex-row">
        <p className="text-[#1F2A37] text-sm font-itcbook">
        Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros
        </p>
        
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={changePage}
        />
      </div>
    </div>
  );
};

export default TableList;
